import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { CrownIcon } from "../../../assets/images/icons/CrownIcon.tsx";
import foxLogo from "../../../assets/images/pngs/FS HIGH RES.png";
import BriaButton from "../../../components/common/BriaButton/BriaButton.tsx";
import ExportButton from "../../../components/common/ExportButton/ExportButton.tsx";
import IframeCloseButton from "../../../components/common/IframeCloseButton/IframeCloseButton.tsx";
import IpProjectsDropdown from "../../../components/common/IpProjectsDropdown/IpProjectsDropdown";
import OrganizationsDropdown from "../../../components/common/OrganizationsDropdown/OrganizationsDropdown.tsx";
import ThemeModeDropdown from "../../../components/common/ThemeModeDropdown/ThemeModeDropdown.tsx";
import UserDropdown from "../../../components/common/UserDropdown/UserDropdown.tsx";
import { APPS, IMAGES_FORMATS } from "../../../constants/AppsConstants.ts";
import LinkConstants from "../../../constants/LinkConstants.ts";
import RouterConstants from "../../../constants/RouterConstants.ts";
import { useLogEvents } from "../../../hooks/useLogEvents.ts";
import useSecureNavigate from "../../../hooks/useSecureNavigate.tsx";
import { useAppStore } from "../../../hooks/useStores.tsx";
import { IframePostMessageActionTypes, IframePostMessageItemTypes } from "../../../models/new-iframe.ts";
import { TextToImageConfigType } from "../../../models/text-to-image.ts";
import iframeStore from "../../../pages/IframeNew/iframe-store.tsx";
import {
	hasOrganization,
	isBriaPublicOrg,
	isFoxOrg,
	isPlatformHubPage,
	isPlaygroundRoute,
	isTextToVector,
} from "../../../utils";
import { getFileExtensionFromUrl, getSafeFileName } from "../../../utils/index.ts";
import HeaderLayout from "../HeaderLayout.tsx";
import styles from "./HubHeader.module.scss";

const HubHeader = () => {
	const navigate = useSecureNavigate();
	const { logImageDownloadEvents } = useLogEvents();
	const { t } = useTranslation("translation", { keyPrefix: "headers.hub" });
	const { playgroundStore, pricingStore } = useAppStore();
	const selectedImages = playgroundStore.getSelectedImages();
	const availableImages = playgroundStore.getAvailableImages();
	const handleBriaLogoClick = () => {
		hasOrganization() ? navigate(RouterConstants.CONSOLE.fullPath) : location.replace(LinkConstants.BRIA_WEBSITE);
	};
	const handleFoxLogoClick = () => {
		// navigate(RouterConstants.APPS.path);
	};

	const productPlacementAppMatch = window.location.pathname.match(/\/(product-placement)\/?([^/]*)/);
	const designEditorAppMatch = window.location.pathname.match(/\/(campaign-editor)\/?([^/]*)/);

	if (designEditorAppMatch) {
		return null;
	}

	const onDownload = async () => {
		const images = selectedImages.length ? selectedImages : availableImages;
		if (images.length) {
			playgroundStore.exportImages(images);
			const firstImage = images[0];
			const defaultFileType = isTextToVector() ? IMAGES_FORMATS.SVG : IMAGES_FORMATS.PNG;
			const fileType = (firstImage?.config as TextToImageConfigType)?.format?.toUpperCase() || defaultFileType;
			logImageDownloadEvents(images, fileType);
		}
	};

	const onIframeSave = async () => {
		const images = selectedImages.length ? selectedImages : availableImages;
		if (images.length) {
			iframeStore.sendExportPostMessage(
				IframePostMessageActionTypes.Save,
				IframePostMessageItemTypes.Image,
				images.map((image) => ({
					type: IframePostMessageItemTypes.Image,
					src: image.url,
					fileName: `${getSafeFileName(playgroundStore.getFileName(image))}.${getFileExtensionFromUrl(image.url)}`,
				})),
			);
		}
	};
	return (
		<HeaderLayout
			className={styles.header}
			logo={isFoxOrg() ?? foxLogo}
			onLogoClick={!isFoxOrg() ? handleBriaLogoClick : handleFoxLogoClick}
		>
			{!isPlatformHubPage() && (
				<>
					{/* {!iframeStore.isIframe() && playgroundStore.selectedConfig === APPS.IMAGE_TO_IMAGE && (
						<Box className={styles.singleModeBanner}>
							<Typography
								className={styles.bannerText}
								dangerouslySetInnerHTML={{ __html: t("singleModeBanner") }}
							></Typography>
							<BriaButton
								className={styles.bannerBtn}
								onClick={() => {
									if (selectedImage) {
										playgroundStore.onAiEditorButtonClick(selectedImage, navigate, true);
									} else {
										window.open(LinkConstants.AI_EDITOR, "_blank");
									}
								}}
								size="small"
							>
								{t("pressHere")}
							</BriaButton>
							{selectedImage?.aiEditorButtonLoading && (
								<CircularProgress color="inherit" size={12} className={styles.loader} />
							)}
						</Box>
					)} */}
					{playgroundStore.selectedConfig === APPS.PRODUCT_PLACEMENT && (
						<ExportButton onDownload={onDownload} onIframeSave={onIframeSave} />
					)}
				</>
			)}

			{!isFoxOrg() && !productPlacementAppMatch && !iframeStore.isIframe() && (
				<>
					<BriaButton
						onClick={() => {
							pricingStore.openPricingFlow();
						}}
						className={styles.hubUpgradeBtn}
					>
						<CrownIcon />
						{t("upgrade")}
					</BriaButton>
					<BriaButton
						buttonType="primaryMedium"
						onClick={() => navigate(RouterConstants.CONSOLE.fullPath)}
						size="small"
					>
						{hasOrganization() ? t("console") : t("getApi")}
					</BriaButton>
				</>
			)}
			<IframeCloseButton />
			{isPlaygroundRoute() && !iframeStore.isIframe() && <IpProjectsDropdown />}
			<OrganizationsDropdown labelFontSize="14px" />
			<UserDropdown />
			{isBriaPublicOrg() && <ThemeModeDropdown />}
		</HeaderLayout>
	);
};

export default observer(HubHeader);
